<div class="container py-5" *ngIf="!isSubscriptionActive && userId">
    <div class="text-center mb-5">
        <h3>Your Subscription Expired!</h3>
        <hr>
        <h5>The last subscription plan - {{ subscriptionName }} - expired on {{ expiresAt | date: "longDate" }}.</h5>
        <h3>&nbsp;</h3>
        <h3>Renew the current subscription or choose a different plan:</h3>
        <div class="row p-5">
            <div class="col-md-6 float-start">
                <button type="button" (click)="renewPlan()" class="btn btn-success btn-lg"><i class="bi bi-repeat"></i> Renew {{ subscriptionName }} Plan</button>
            </div>
            <div class="col-md-6 float-start">
                <button type="button" class="btn btn-primary btn-lg" (click)="enablePlanSelectorForInactive()"><i class="bi bi-list-check"></i> Choose A Different Plan</button>
            </div>
        </div>
    </div>
</div>
<div class="container py-5" *ngIf="shouldShowPlanCards && userId">
  <h2 class="text-center mb-4">Upgrade Subscription Plan</h2>
  <p class="text-center text-muted mb-5">
    Your subscription plan allows for a maximum of {{ currentBoatLimitLabel }} boats, to add more boats you need to upgrade your plan.
  </p>
  <div class="row row-cols-1 row-cols-md-4 mb-3 g-4">
  <div class="col" *ngFor="let plan of plans()">
    <div class="card h-100 rounded-3 shadow-sm"
      [class.border-primary]="plan.level === recommendedPlan()?.level"
      [class.opacity-50]="plan.level === subscriptionLevel"
      [class.pointer-events-none]="plan.level === subscriptionLevel"
      >
      <div class="card-header py-3"
      [ngClass]="{
        'bg-primary text-white': plan.level === recommendedPlan()?.level,
        'bg-light text-muted': plan.level === subscriptionLevel || plan.level !== recommendedPlan()?.level
      }">
        <h4 class="my-0 fw-normal text-center">{{ plan.name }}</h4>
      </div>
      <div class="card-body px-4 text-start">
        <h1 class="card-title pricing-card-title text-center">
          {{ plan.price | currency:(plan.currency || 'EUR'):'symbol':'1.0-2' }}
          <small class="text-muted fw-light">
            {{ plan.billingPeriod === 'one-time' ? 'one-time' : '/' + (plan.billingPeriod === 'monthly' ? 'mo' : 'yr') }}
          </small>
        </h1>

        <ul class="list-unstyled mt-3 mb-4">
          <li><strong>{{ plan.boats }}</strong></li>
          <li class="text-muted">{{ plan.description }}</li>
          <li class="mt-3" *ngFor="let feature of plan.features">
            <i class="bi bi-check-circle-fill text-success me-2"></i>{{ feature }}
          </li>
        </ul>

        <div *ngIf="plan.addons?.length">
          <h6 class="fw-bold">Add More Boats</h6>
          <ul class="list-unstyled small text-muted">
            <li *ngFor="let addon of plan.addons ?? []">
              +{{ addon.boats }} boats: {{ addon.price | currency:(plan.currency || 'EUR'):'symbol':'1.0-2' }}/{{ plan.billingPeriod === 'one-time' ? 'one-time' : (plan.billingPeriod === 'monthly' ? 'month' : 'year') }}
            </li>
          </ul>
        </div>

        <div class="text-center mt-4">
          <button type="button"
            (click)="choosePlan(plan)"
            [disabled]="!canChoosePlan(plan)"

            class="w-100 btn btn-lg"
            [ngClass]="{
              'btn-outline-primary': plan.level !== recommendedPlan()?.level && canChoosePlan(plan),
              'btn-primary': plan.level === recommendedPlan()?.level && canChoosePlan(plan),
              'btn-secondary': !canChoosePlan(plan)
            }">
            {{ plan.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
